import React, { useEffect, useState } from 'react';
import { MyFooter } from '../landingpage/MyFooter';
import { MyHeader } from '../header/MyHeader';
import MenuComponent from '../component/MenueComponent';

type ISatz = {
  id: number,
  name: string,
  verein: string,
  kategorieid: number,
  kategorieName: string,
  startnummer: string,
  ereignis: string,
  geschlecht: string,
}

type ITeilnehmertabelle = {
  kategorien: IKategorie[],
}

type IKategorie = {
  id: number,
  name: string,
  teilnehmer: ITeilnehmer[],
}

type ITeilnehmer = {
  id: number,
  name: string,
  startnummer: string,
  verein: string,
  geschlecht: string,
}

export function Teilnehmerliste() {

  const [teilnehmerTabelle, setTeilnehmerTabelle] = useState<ITeilnehmertabelle>();
  const [data, setData] = useState<ISatz[]>([]);

  const getData = () => {

    fetch(process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_PATH! + "/restGetTeilnehmerQuery.rest")
      .then(response => response.json())
      .then(setData)
      .catch((e) => console.log(e));
  }

  useEffect(() => {
    const teilnehmer: ITeilnehmertabelle = { kategorien: [] };
    data.forEach(element => {
      if (teilnehmer.kategorien.filter(e => e.id === element.kategorieid).length === 0)
        teilnehmer.kategorien.push({ id: element.kategorieid, name: element.kategorieName, teilnehmer: [] });

      const arrKategorien = teilnehmer.kategorien.filter(e => e.id === element.kategorieid);
      const arrTeilnehmer = arrKategorien[0].teilnehmer;
      arrTeilnehmer.push({ id: element.id, name: element.name, verein: element.verein, startnummer: element.startnummer, geschlecht: element.geschlecht });
    });

    setTeilnehmerTabelle(teilnehmer);

  }, [data]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <>

      {/*<MyHeader />*/}

      <div className="max-w-7xl mx-auto px-4">

        <MenuComponent aktuelleseite="teilnehmerliste" />

        <div className="col-md-12 ml-sm-auto col-lg-12 px-4" role="main">

          <p className="max-w text-center text-2xl mt-4">Teilnehmerliste</p>

          <p className="max-w text-center text-xl mt-4">{data?.at(0)?.ereignis}</p>

          {data.length === 0 && <>
            <p>Kein aktuelles Ereignis vorhanden</p>
          </>}

          {data.length > 0 && <>
            <span>Gesamtanzahl Teilnehmer: {data.length}</span>

            {teilnehmerTabelle?.kategorien.map((e, index) =>
              <>
                <br /><br /><br />
                <h5>{e.name}</h5>
                <table className="table">
                  <tr><th>Name</th><th>Startnummer</th><th>Verein</th></tr>
                  {
                    e.teilnehmer
                      .map((e1) =>
                        <>
                          <tr>
                            <td>{e1.name} ({e1.geschlecht})</td>
                            <td>{e1.startnummer}</td>
                            <td>{e1.verein}</td>
                          </tr>
                        </>)
                  }
                </table>
                Anzahl Teilnehmer {e.name}: {e.teilnehmer.length}
              </>
            )
            }

          </>}

        </div>
      </div>

      <MyFooter />
    </>
  );
}

export default Teilnehmerliste;